import { cloneDeep, get } from 'lodash';
import moment from 'moment-timezone';
import { EApplyTo } from 'src/pages/StoreVoucher/Detail/UsageCondition';

const symbol = '+++';
const generateName = (p, c) => {
  return `${p}${symbol}${c}`;
};

const _integerGifts = (data) => {
  const _re = (data || []).reduce((pre, now) => {
    const obj = _integerSingleGift(now);
    return {
      ...pre,
      ...(obj || {}),
    };
  }, {});
  return _re;
};

const _integerSingleGift = (data) => {
  const {
    products: salesChannelProductList,
    quantities: productQuantity,
    salesChannelUuid,
  } = data || {};

  const dict = (productQuantity || []).reduce((pre, now) => {
    const { children, quantity, uuid } = now;
    if (children) {
      const cData = children.reduce((cPre, cNow) => {
        const { uuid: childUuid, quantity: childQuantity } = cNow;
        const name = generateName(uuid, childUuid);

        return {
          ...cPre,
          [name]: childQuantity,
        };
      }, {});

      return { ...pre, ...cData };
    }
    return { ...pre, [uuid]: quantity };
  }, []);

  const _salesChannelProductList = (salesChannelProductList || []).reduce(
    (pre, now) => {
      const { children, uuid } = now;

      if (children && (children || []).length > 0) {
        const _children = children.map((i) => {
          const { uuid: cUuid } = i;
          const _name = generateName(uuid, cUuid);
          const q = dict[_name] || 1;
          return { ...i, quantity: q };
        });

        return [...pre, { ...now, children: _children }];
      } else {
        const quantity = dict[uuid] || 1;
        return [...pre, { ...now, quantity }];
      }
    },
    [],
  );

  return { [salesChannelUuid]: _salesChannelProductList };
};

const _separateGifts = (data) => {
  return Object.keys(data).map((uuid) => {
    const _d = data[uuid] || {};
    const re = _separateSingleGift(_d);

    return {
      ...(re || {}),
      salesChannelUuid: uuid,
    };
  });
};

const _separateSingleGift = (data) => {
  const salesChannelProductList = cloneDeep(data || []);
  const productQuantity = (data || []).map((i) => {
    const { uuid, quantity, children } = i;
    if (children) {
      const _children = children.map((child) => {
        const { quantity, uuid: cUuid } = child;
        return { uuid: cUuid, quantity };
      });
      return { uuid, children: _children };
    } else {
      return {
        uuid,
        quantity,
      };
    }
  });
  return {
    products: salesChannelProductList,
    quantities: productQuantity,
  };
};

const convertDataFromServer = (data) => {
  const { customerDatabase, salesChannels, voucherMethod, customerCondition } =
    data;
  const _customerDatabase = (customerDatabase || {}).uuid;
  const _salesChannels = (salesChannels || []).map((i) => i.uuid);
  const salesChannelGifts = get(voucherMethod, 'salesChannelGifts') || [];
  const _salesChannelGifts = _integerGifts(salesChannelGifts);

  const vouchers = get(customerCondition, 'vouchers') || [];
  const _vouchers = vouchers.map((i) => i.uuid);
  return {
    ...(data || {}),
    customerDatabase: _customerDatabase,
    salesChannels: _salesChannels,
    voucherMethod: {
      ...(voucherMethod || {}),
      salesChannelGifts: _salesChannelGifts,
    },
    customerCondition: {
      ...(customerCondition || {}),
      vouchers: _vouchers,
    },
  };
};

const convertDataFromState = (data) => {
  const {
    customerDatabase,
    salesChannels,
    voucherMethod,
    usageCondition,
    voucherType,
    customerCondition,
  } = data;
  const { basedOn } = usageCondition || {};
  const _customerDatabase = { uuid: customerDatabase };
  const _salesChannels = (salesChannels || []).map((i) => ({ uuid: i }));
  const salesChannelGifts = get(voucherMethod, 'salesChannelGifts') || {};

  const _salesChannelGifts = _separateGifts(salesChannelGifts);
  const vouchers = get(customerCondition, 'vouchers') || [];
  const _vouchers = vouchers.map((i) => ({ uuid: i }));

  return {
    ...(data || {}),
    customerDatabase: _customerDatabase,
    salesChannels: _salesChannels,
    voucherMethod: {
      ...(voucherMethod || {}),
      salesChannelGifts: _salesChannelGifts,
      voucherType,
    },
    usageCondition: basedOn === EApplyTo.None ? null : usageCondition,
    customerCondition: {
      ...(customerCondition || {}),
      vouchers: _vouchers,
    },
  };
};

const handleOnCheckTime = (activeTime, idOfTimeZone) => {
  const { beginDate, beginTime, endDate, endTime } = activeTime || {};
  if (beginDate && beginTime && !endDate && !endTime) {
    return { valid: true };
  }
  if (beginDate && beginTime && endDate && endTime) {
    const currentZoneName = moment.tz.guess();
    const end = `${endDate} ${endTime}`;
    const isAfter = moment
      .tz(end, idOfTimeZone)
      .isAfter(moment.tz(new Date(), currentZoneName));
    return { valid: isAfter, message: 'Unable to publish an expired discount' };
  }
  return { valid: false };
};

export {
  _integerGifts,
  _separateGifts,
  convertDataFromServer,
  convertDataFromState,
  handleOnCheckTime,
};
